import { useMemo } from "react"
import { ICabCapacityWarningProps } from "./store"
import { getCabCapacityWarningInfo } from "./utils"
import { Alert } from "@sembark-travel/ui/base"

export function CabCapacityWarningMessage({
	children,
	noOfAdults,
	messageType,
	cabs,
}: ICabCapacityWarningProps) {
	const warningInfo = useMemo(
		() =>
			getCabCapacityWarningInfo({ children, noOfAdults, messageType, cabs }),
		[children, noOfAdults, messageType, cabs]
	)
	if (warningInfo.hasWarning) {
		return (
			<Alert status="warning" inline>
				{warningInfo.message}
			</Alert>
		)
	}
	return null
}
